import { useMemo } from 'react';

export const useCostOverrideTableDimensions = () => {
  return useMemo(
    () => ({
      loading: false,
      projectDimensions: [],
      requiredDimensions: []
    }),
    []
  );
};

export default useCostOverrideTableDimensions;
